import React from 'react';
import { Card, CardContent, Badge } from '@ncoder/ui';
import { CheckCircle, XCircle } from 'lucide-react';

interface TestResultCardProps {
  scenario: string;
  status: 'passed' | 'failed';
  response: string;
  score: number;
  timestamp: string;
}

export const TestResultCard: React.FC<TestResultCardProps> = ({
  scenario,
  status,
  response,
  score,
  timestamp,
}) => {
  return (
    <Card>
      <CardContent className="p-4">
        <div className="flex items-center justify-between mb-3">
          <div className="flex items-center gap-2">
            <h3 className="font-medium">{scenario}</h3>
            <Badge variant={status === 'passed' ? 'default' : 'destructive'}>
              {status === 'passed' ? (
                <CheckCircle className="h-3 w-3 mr-1" />
              ) : (
                <XCircle className="h-3 w-3 mr-1" />
              )}
              {status}
            </Badge>
          </div>
          <div className="flex items-center gap-2">
            <span className="text-sm font-medium">Score: {score}%</span>
            <span className="text-xs text-muted-foreground">{timestamp}</span>
          </div>
        </div>
        <div className="p-3 bg-muted rounded text-sm">
          <p className="font-medium mb-1">Agent Response:</p>
          <p className="text-muted-foreground">{response}</p>
        </div>
      </CardContent>
    </Card>
  );
};
